import React from "react";
import "./Accordion.css";

type AccordionProps = {
  items: Record<string, string>;
};

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [expandedSection, setExpandedSection] = React.useState<string | null>(
    null,
  );

  const toggleSection = (section: string) => {
    setExpandedSection((current) => (current === section ? null : section));
  };

  return (
    <div className="accordion-section">
      {Object.entries(items).map(([title, content]) => (
        <div className="accordion-item" key={title}>
          <button
            className={`accordion-header ${expandedSection === title ? "active" : ""}`}
            key={title}
            onClick={() => toggleSection(title)}
          >
            <div className="accordion-title-group">
              <span>{title}</span>
            </div>
            <div className="accordion-icon">▼</div>
          </button>
          <div
            className={`accordion-body ${expandedSection === title ? "open" : ""}`}
          >
            <p>{content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
